import { cloneDeep } from "lodash";
import { UPDATE_MESSAGE_STATUS, GET_CONVERSATION_LIST, GET_CONVERSATION_MESSAGE_HISOTRY, INITIATE_CONVERSATION, SEND_MESSAGE, HANDLE_INCOMING_MESSAGE, HANDLE_READ_MESSAGE_CALLBACK, HANDLE_RECEIVER_READ_MESSAGE, HANDLE_MESSAGE_EDIT, HANDLE_MESSAGE_REMOVE, HANDLE_ONLINE_STATUS } from "store/actions/clientMessaging";

const initialState = {
  conversation: null,
};

const initiateConversation = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
    callback(data.body);
  }

  const conversation = data?.body;
  if(!conversation) {
    return state;
  }

  const newConversation = {
    conversation_id: conversation.id,
    latest_message_at: null,
    pract_id: conversation.pract_id,
    client_id: conversation.client_id,
    unread_count: conversation?.unread_count || 0,
    latest_message_id: null,
    sender_id: conversation.pract_id,
    receiver_id: conversation.client_id,
    message: "",
    created_at: null,
    pract_first_name: conversation.first_name,
    pract_last_name: conversation.last_name,
    active_status: conversation.active_status,
  }

  const stateObj = {
    ...state,
    conversation: newConversation,
  };
  return stateObj;
}

// const getConversationList = (state, payload) => {
//   const { data, callback } = payload;
//   if (typeof callback === 'function') {
//     callback(data.body);
//   }
//   const stateObj = {
//     ...state,
//     conversationList: data?.body?.data,
//   };
//   return stateObj;
// }

const getConversationMessageHistory = (state, payload) => {
  const { data, lastMessageId, callback } = payload;
  if (typeof callback === 'function') {
    callback(data.body);
  }

  let newMessages = data?.body?.data;

  if (!Array.isArray(newMessages) || newMessages.length === 0) {
    return state;
  }

  newMessages = newMessages.reverse();


  const conversation = cloneDeep(state.conversation);

  // replace existing messages if not a pagniated request
  if(!lastMessageId) {
    conversation.messages = newMessages;  
  } else {
    const existingMessages = conversation.messages || [];
    conversation.messages = [...newMessages, ...existingMessages];
  }
  
  conversation.totalMessagesCount = data?.body?.total_count;

  return {
    ...state,
    conversation: conversation,
  };
}

const sendMessageToClient = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const conversation = addMessageToConversation(state, data, "pending");

  return {
    ...state,
    conversation,
  };
};

const updateMessageStatus = (state, payload) => {
  const { data, status, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const idempotencyId = data?.idempotencyId;
  const messageId = data?.messageId;

  if (!idempotencyId || !messageId) {
    return state;
  }

  // Clone conversation list
  const conversation = cloneDeep(state.conversation);

  const existingMessages = conversation.messages || [];

  // Find the message by idempotencyId
  const messageIndex = existingMessages.findIndex(
    (msg) => msg.idempotencyId === idempotencyId
  );

  if (messageIndex === -1) {
    return state; // Message not found
  }

  // Update the message status and ID
  existingMessages[messageIndex] = {
    ...existingMessages[messageIndex],
    status,
    id: messageId,
  };

  // Update messages in conversation
  conversation.messages = existingMessages;

  // Return updated state
  return {
    ...state,
    conversation,
  };
};

const handleIncomingMessage = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const updatedConversation = addMessageToConversation(state, data, "", true);

  return {
    ...state,
    conversation: updatedConversation,
  };
};

const addMessageToConversation = (state, message, status, isIncoming = false) => {
  const idempotencyId = message?.idempotencyId;

  if (!idempotencyId || !message) {
    return state.conversation;
  }

  // Clone the conversation
  const conversation = cloneDeep(state.conversation);
  
  const existingMessages = conversation.messages || [];

  // Prevent duplicate message by idempotencyId
  const isDuplicate = existingMessages.some(
    (msg) => msg.idempotencyId === idempotencyId
  );

  if (isDuplicate) {
    return state.conversation; // Don't add duplicate
  }

  // Append new message
  conversation.messages = [
    ...existingMessages,
    {
      ...message,
      id: message.messageId,
      status,
    }
  ];

  // if message is incoming, increase current conversation unread msg count
  if(isIncoming) {
    conversation.unread_count = (conversation.unread_count || 0) + 1;
  }

  conversation.message = message.message;

  return conversation;
}

const handleMsgReadCallback = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const newUnreadCount = data?.unread_count;

  // Clone conversation list
  const conversation = cloneDeep(state.conversation);

  // update new unread count of conversation
  conversation.unread_count = newUnreadCount;

  // Return updated state
  return {
    ...state,
    conversation: conversation,
  };
};

const handleReceiverMsgRead = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const conversationId = data?.conversation_id;
  const msgIds = data?.msg_ids?.length && data?.msg_ids.map(id => Number(id));

  if (!conversationId || !msgIds) {
    return state;
  }

  const conversation = cloneDeep(state.conversation);
  if(!conversation?.messages?.length) {
    return;
  }

  // update messages read status
  conversation.messages = conversation.messages.map(m => {
    if(msgIds.includes(Number(m.id))) {
      m.is_read = true;
    }
    return m;
  });

  // Return updated state
  return {
    ...state,
    conversation,
  };
}

const handleEditMessage = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const messageId = data?.message_id;
  const editedMessage = data?.message;
  const editedAt = data?.edited_at || new Date();

  if (!messageId || !editedMessage) {
    return state;
  }

  const conversation = cloneDeep(state.conversation);
  
  // Update the message in the conversation
  conversation.messages = conversation.messages.map(m => {
    if (m.id === messageId) {
      return { ...m, message: editedMessage, edited_at: editedAt };
    }
    return m;
  });

  // Return updated state
  return {
    ...state,
    conversation,
  };
}

const handleRemoveMessage = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const messageId = data?.message_id;
  const deletedAt = data?.deleted_at || new Date();

  if (!messageId) {
    return state;
  }

  const conversation = cloneDeep(state.conversation);

  // Remove the message from the conversation
  conversation.messages = conversation.messages.map(m => {
    if (m.id === messageId) {
      return { ...m, is_deleted: true, deleted_at: deletedAt };
    }
    return m;
  });

  // Return updated state
  return {
    ...state,
    conversation,
  };
}

const handleOnlineStatus = (state, payload) => {
  const { data, callback } = payload;

  if (typeof callback === 'function') {
    callback(data);
  }

  const conversation = cloneDeep(state.conversation);

  // Update online status
  conversation.active_status = data.status === "online";

  // Return updated state
  return {
    ...state,
    conversation,
  };
}

const ClientMessaging = (state = initialState, { type, payload = null }) => {
  switch (type) {
      case INITIATE_CONVERSATION:
        return initiateConversation(state, payload);
      // case GET_CONVERSATION_LIST:
      //   return getConversationList(state, payload);
      case GET_CONVERSATION_MESSAGE_HISOTRY:
        return getConversationMessageHistory(state, payload);
      case SEND_MESSAGE:
        return sendMessageToClient(state, payload);
      case UPDATE_MESSAGE_STATUS:
        return updateMessageStatus(state, payload);
      case HANDLE_INCOMING_MESSAGE:
        return handleIncomingMessage(state, payload);
      case HANDLE_READ_MESSAGE_CALLBACK:
        return handleMsgReadCallback(state, payload);
      case HANDLE_RECEIVER_READ_MESSAGE:
        return handleReceiverMsgRead(state, payload);
      case HANDLE_MESSAGE_EDIT:
        return handleEditMessage(state, payload);
      case HANDLE_MESSAGE_REMOVE:
        return handleRemoveMessage(state, payload);
      case HANDLE_ONLINE_STATUS:
        return handleOnlineStatus(state, payload);
      default:
        return state;
  };
}
export default ClientMessaging;